/* @flow */

import { type StateColors } from '../utils/types';

const getCorFundo = (primeiraLetra: string): StateColors => {
    if (/[a-e]/i.test(primeiraLetra)) {
        return 'success';
    }

    if (/[f-j]/i.test(primeiraLetra)) {
        return 'info';
    }

    if (/[k-p]/i.test(primeiraLetra)) {
        return 'warning';
    }

    if (/[q-u]/i.test(primeiraLetra)) {
        return 'danger';
    }

    return 'primary';
};

export default getCorFundo;
